// import { fetchInstagramPhoto, fetchInstagramPhotos } from './api'
import { Skeleton } from '@mui/material'
import { useEffect, useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import { CaretDown, CaretUp, InstagramLogo } from '@phosphor-icons/react'
import PerfilInstagram from '../images/nutri.png'
import InstagramLaptop from '../images/InstagramLaptop.png'
import InstagramNutri from '../images/nutriInsta.png'
import InstagramLogoImage from '../images/InstagramLogo.svg'
import { parseISO, format } from 'date-fns'




import axios from 'axios'












// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import 'react-lazy-load-image-component/src/effects/blur.css';

import pt from 'date-fns/locale/pt'

const accessToken = 'IGQWRQMkJzY1lZAWmliLThnMG53S0F3eGNfWEdOOHVlbnRJNlZAQNHVkUlI2eFU0dXdlZA1RSVWNIWEN6VHVsMWV4WUdYdHp0T1d3UkNIOGlQOXdXU19RRTVNRTdwOVNQRWdJb0ZAaOU9VUjlyd2RZAS1RqSE9aY2NsQUUZD'

interface InstagramProps {
  id: string
  username: string
  timestamp: string
  permalink: string
  media_url: string
  thumbnail_url: string
  media_type: string
  caption: string
}

interface LongLivedTokenProps {
  access_token: string
  token_type: string
  expires_in: number
}

export const updateLongLivedToken = async (): Promise<
  LongLivedTokenProps[]
> => {
  try {
    const response = await axios.get(
      `https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&&access_token=${accessToken}'`,
    )
    const tokenData: LongLivedTokenProps[] = response.data.data
    return tokenData
  } catch (error) {
    console.error('Error fetching Instagram token:', error)
    return {} as LongLivedTokenProps[]
  }
}

export const fetchInstagramPhotos = async (): Promise<InstagramProps[]> => {
  try {
    const response = await axios.get(
      `https://graph.instagram.com/me/media?fields=id,media_url,permalink,caption,timestamp,username,media_type,thumbnail_url&access_token=${accessToken}`,
    )
    const photos: InstagramProps[] = response.data.data
    return photos
  } catch (error) {
    console.error('Error fetching Instagram photos:', error)
    return {} as InstagramProps[]
  }
}

export const fetchInstagramPhoto = async (
  id: string,
): Promise<InstagramProps> => {
  try {
    const response = await axios.get(
      `https://graph.instagram.com/${id}?fields=id,media_url,permalink,caption,timestamp,username,media_type,thumbnail_url&access_token=${accessToken}`,
    )
    const photo: InstagramProps = response.data

    return photo
  } catch (error) {
    console.error('Error fetching Instagram photo:', error)
    return {} as InstagramProps
  }
}

interface InstagramProps {
  id: string
  username: string
  timestamp: string
  permalink: string
  media_url: string
  thumbnail_url: string
  media_type: string
  caption: string
}

export function Instagram() {
  const [isLoadingImage, setIsLoadingImage] = useState(true)
  const [isLoadingCarousel, setIsLoadingCarousel] = useState(true)
  const [idOfClickedImage, setIdOfClickedImage] = useState('')

  const [activeThumb, setActiveThumb] = useState<InstagramProps>(
    {} as InstagramProps,
  )
  const [activeBlurImage, setActiveBlurImage] = useState<string | undefined>(
    'data:image/jpeg;base64,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',
  )

  const [activeThumbDateFormated, setActiveThumbDateFormated] = useState('')

  const [photos, setPhotos] = useState<InstagramProps[]>([])

  function createDate(dateString: string, dateType: string) {
    const date = parseISO(dateString)

    if (dateType === 'default') {
      const formattedCreatedDate = format(date, "dd'/'MM'/'yyyy'", {
        locale: pt,
      })

      return formattedCreatedDate
    } else {
      const formattedCreatedDate = format(date, "dd' ' MMMM', 'yyyy'", {
        locale: pt,
      })

      setActiveThumbDateFormated(formattedCreatedDate)
    }
  }

  function truncateText(text: string, wordsLimit: number) {
    const words = text.split(' ')

    if (words.length > wordsLimit) {
      return words.slice(0, wordsLimit).join(' ') + '... '
    }

    return text
  }

  async function handleImageClick(id: string) {
    setIdOfClickedImage(id)
    setIsLoadingImage(true)
    const getPhoto = async () => {
      try {
        const fetchedPhoto = await fetchInstagramPhoto(id)
        setActiveThumb(fetchedPhoto)
      } catch {
        console.log('Erro: ')
      } finally {
        createDate(activeThumb.timestamp, '')
      }
    }

    getPhoto()
  }

  async function convertImageToBase64(imageSrc: string): Promise<string> {
    try {
      const response = await fetch(imageSrc)
      const blob = await response.blob()
      const buffer = await blob.arrayBuffer()
      const base64String = btoa(
        new Uint8Array(buffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
        ),
      )
      return `data:${response.headers.get(
        'content-type',
      )};base64,${base64String}`
    } catch (error) {
      console.log(error)
      return ''
    }
  }

  useEffect(() => {
    const getPhotos = async () => {
      try {
        const fetchedPhotos = await fetchInstagramPhotos()
        // return fetchedPhotos

        setPhotos(fetchedPhotos)
        setActiveThumb(fetchedPhotos[0])
      } catch (error) {
        console.log('Erro: ', error)
      } finally {
        setIsLoadingCarousel(false)
      }
    }

    getPhotos()
  }, [])

  useEffect(() => {
    if (photos.length > 0) {
      createDate(activeThumb.timestamp, '')

      const indexOfClickedImage = photos.findIndex(
        (photo) => photo.id === idOfClickedImage,
      )

      const updateActiveBlurImage = async () => {
        try {
          if(photos[indexOfClickedImage]?.media_type !== undefined) {
            if (photos[indexOfClickedImage]?.media_type === 'VIDEO') {
              const base64Image = await convertImageToBase64(
                photos[indexOfClickedImage].thumbnail_url,
              )
  
              setActiveBlurImage(base64Image)
            } else {
              const base64Image = await convertImageToBase64(
                photos[indexOfClickedImage]?.media_url,
              )
  
              setActiveBlurImage(base64Image)
            }
          }

        } catch (error) {
          console.log('Error:', error)
        } finally {
          setIsLoadingImage(false)
        }
      }

      updateActiveBlurImage()
    }
  }, [photos, activeThumb])


  return (
    <>
      <section className="min-h-screen px-6 pb-6 xl:mt-0 lg:mx-28 mb-16 lg:mb-32">
        <div className="flex flex-row">
          <div className="text-3xl md:text-5xl w-full font-alt pb-6 lg:w-1/2">
            <h1>Instagram</h1>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center lg:flex-row">
          <div className="w-full lg:w-1/2 lg:pt-0">
            <div className="flex h-full flex-col">
              <div className="flex flex-col items-center justify-center gap-y-4 md:gap-y-2 mt-8">
                <div className="w-full flex justify-start text-start">
                  <h2 className='text-lg md:text-2xl'>Acompanhe a sua nutricionista no Instagram</h2>
                </div>

                <div className="w-full flex justify-center text-center">
                  <h2 className='text-lg md:text-2xl'>Siga para conteúdos embasados cientificamente</h2>
                </div>

                <div className="w-full flex justify-start text-start">
                  <h2 className='text-lg md:text-2xl'>Encontre receitas e sugestões para sua saúde e rotina</h2>
                </div>
              </div>

              <div className="relative flex items-center justify-center">
                <a
                  href="https://www.instagram.com/nutricionistaelieteborges/"
                  target="_blank"
                  rel="noreferrer"
                  className="absolute uppercase rounded-lg border-2 border-primary-500 bg-background-color px-4 py-1 text-primary-500"
                >
                  Visitar Instagram
                </a>
                <img
                  src={InstagramLaptop}
                  width={500}
                  alt="Imagem de notebook com Instagram aberto."
                />
              </div>

              <div className="hidden md:flex absolute left-0">
                <img src={InstagramLogoImage} alt="" width={250} />
              </div>
            </div>
          </div>

          <div className="relative flex h-full w-full flex-row items-start justify-evenly lg:w-1/2 lg:justify-between lg:pr-8">
            {/* <span className="absolute -right-[1px] bottom-0 top-0 hidden h-full w-[1px] bg-red-600 content-none lg:block"></span> */}
            {photos[0] !== undefined ? (
              <>
                {isLoadingImage ? (
                  <div className="flex w-[70%] max-w-[470px] flex-col gap-y-1  text-xs">
                    <div className="flex flex-row items-center justify-between">
                      <div className="flex flex-row items-center gap-x-2">
                        <Skeleton
                          variant="circular"
                          width={24}
                          height={24}
                          className="rounded-full border-none"
                          sx={{ bgcolor: '#D6D6D6' }}
                        />
                        <div>
                          <Skeleton
                            variant="text"
                            className="border-none"
                            width={40}
                            sx={{ fontSize: '1rem', bgcolor: '#D6D6D6' }}
                          />
                        </div>
                      </div>

                      <div>
                        <Skeleton
                          variant="text"
                          className="border-none"
                          width={100}
                          sx={{ fontSize: '1rem', bgcolor: '#D6D6D6' }}
                        />
                      </div>
                    </div>

                    <div className="flex flex-col border-none lg:h-full lg:w-full">
                      <Skeleton
                        variant="rectangular"
                        className="rounded-lg border-none"
                        sx={{ bgcolor: '#D6D6D6', paddingTop: '100%' }}
                      />
                    </div>

                    <div>
                      <Skeleton
                        variant="rectangular"
                        className="w-full border-none"
                        sx={{ bgcolor: '#D6D6D6', paddingTop: '10%' }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex w-[70%] max-w-[470px] flex-col gap-y-1 text-xs">
                    <div className="flex flex-row items-center justify-between">
                      <div className="w-full flex flex-row items-center gap-x-2">
                        <a
                          href="https://www.instagram.com/nutricionistaelieteborges/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="h-6 w-6 cursor-pointer border-primary-500 border-[1px] rounded-full bg-cover object-cover object-top"
                            src={PerfilInstagram}
                            height={24}
                            width={24}
                            alt="Foto de perfil da Nutricionista"
                          />
                        </a>

                        <div className='w-full flex flex-col md:flex-row md:justify-between gap-y-0'>
                          <a
                            href="https://www.instagram.com/nutricionistaelieteborges/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className='text-xs'>nutricionistaelieteborges</span>
                          </a>

                          <a
                            href="https://www.instagram.com/nutricionistaelieteborges/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className='text-[0.60rem] md:text-xs'>{activeThumbDateFormated}</span>
                          </a>
                        </div>
                      </div>


                    </div>

                    <div className="flex cursor-pointer flex-col rounded-lg border-none object-top lg:h-full lg:w-full">
                      <a
                        href={activeThumb.permalink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {activeThumb.media_type === 'VIDEO' ? (
                          // <video
                          //   controls
                          //   className="max-h-[470px] w-[100%] max-w-[470px] cursor-pointer rounded-lg border-none bg-cover object-cover object-top"
                          // >
                          //   <source src={activeThumb.media_url} type="video/mp4" />
                          // </video>

                          <div className="relative flex cursor-pointer flex-col rounded-lg border-none object-top lg:h-full lg:w-full">
                            <img
                              className="max-h-96 w-[100%] max-w-[470px] cursor-pointer rounded-lg border-none bg-cover object-cover object-top"
                              src={activeThumb.thumbnail_url.replace(
                                /^[^.]*/,
                                'https://scontent-sin6-3',
                              )}
                              width={200}
                              height={200}
                              alt="Foto do Instagram selecionada"
                              // onLoadingComplete={() => setIsLoadingImage(false)}
                              placeholder="blur"
                              // blurDataURL={activeBlurImage}
                            />

                            <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center">
                              <div className="flex flex-row items-center gap-x-2 border-2 border-primary-500 rounded-lg bg-background-color px-4 py-2">
                                <InstagramLogo size={24} color="#333620" />{' '}
                                Clique para Assistir
                              </div>
                            </div>
                          </div>
                        ) : (
                          <img
                            className="cursor-pointer rounded-lg border-none bg-cover object-cover object-top"
                            src={activeThumb.media_url.replace(
                              /^[^.]*/,
                              'https://scontent-sin6-3',
                            )}
                            width={470}
                            height={415}
                            alt="Foto do Instagram selecionada"
                            // onLoadingComplete={() => setIsLoadingImage(false)}
                            placeholder="blur"
                            // blurDataURL={activeBlurImage}
                          />
                        )}
                      </a>
                    </div>

                    <div>
                      {'caption' in activeThumb ? (
                        <>
                          <span>{truncateText(activeThumb.caption, 15)}</span>

                          {activeThumb.caption.split(' ').length > 15 ? (
                            <span className="font-medium">
                              [Para ler o texto completo, acesse o post clicando
                              na publicação acima.]
                            </span>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                )}

                <div className="flex h-[470px] w-32 flex-col items-center justify-between">
                  <div className="my-custom-prev-button cursor-pointer">
                    <CaretUp size={32} color="#333620" />
                  </div>

                  {isLoadingCarousel ? (
                    <Skeleton
                      variant="rectangular"
                      width={80}
                      height={400}
                      className="rounded-md"
                      sx={{ bgcolor: '#D6D6D6' }}
                    />
                  ) : (
                    <Swiper
                      navigation={{
                        prevEl: '.my-custom-prev-button',
                        nextEl: '.my-custom-next-button',
                      }}
                      direction="vertical"
                      slidesPerView={4}
                      spaceBetween={30}
                      modules={[Navigation]}
                      grabCursor={true}
                    >
                      {photos.map((image, index) => (
                        <SwiperSlide key={index} className='!h-20'>
                          <LazyLoadImage
                            key={index}
                            src={
                              image.media_type === 'VIDEO'
                                ? image.thumbnail_url
                                : image.media_url
                            }
                            alt={`Foto do Instagram para selecionar`}
                            width={80}
                            height={80}
                            effect="blur"
                            className="img-lazy h-20 w-20 cursor-grab rounded-md border object-cover object-top"
                            onClick={() => handleImageClick(image.id)}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}

                  <div className="my-custom-next-button cursor-pointer">
                    <CaretDown size={32} color="#333620" />
                  </div>
                </div>
              </>
            ) : (
              <div className="w-full flex items-center justify-center">
                <img
                  className='hidden lg:flex lg:w-[350px] xl:w-[400px]'
                  src={InstagramNutri}
                  alt="Imagem da nutricionista Eliete Borges segurando uma maça verde."
                />
              </div>
            )}
          </div>
        </div>

          {/* <div className="w-full pb-32 lg:w-1/2 lg:pl-8 lg:pt-0"> */}

      </section>
    </>
  )
}